import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DeliveryResourceService, DeliveryRangeModel } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxDeliveryService {
  constructor(
    private api: DeliveryResourceService,
  ) {
  }

  getDeliveryRangeById(id: number): Promise<DeliveryRangeModel> {
    return firstValueFrom(this.api.getDeliveryRangeById(id));
  }

  releaseRange(rangeId: number, orderId: number): Promise<void> {
    return firstValueFrom(this.api.releaseDeliveryRange(rangeId, orderId));
  }

  reserveRange(courierId: number, orderId: number): Promise<void> {
    return firstValueFrom(this.api.reserveDeliveryRange(courierId, orderId));
  }

  getDeliveryRanges(params: { date: string, storeId: number }): Promise<DeliveryRangeModel[]> {
    return firstValueFrom(this.api.getDeliveryRangeList(params.date, params.storeId));
  }

  getNearestDeliveryRanges(params: {
    date: string;
    cityId: number;
    brandId: number;
    point: { latitude: number; longitude: number; };
    products: {
      productDefinitionId: number;
      amount: number;
      priceAmount: number;
    }[];
  }): Promise<DeliveryRangeModel[]> {
    return firstValueFrom(this.api.getDeliveryNearestRanges(params as any));
  }
}
